<div class="w-full custom-form flex items-center">
  @if (!loading()) {
    <mat-form-field class="w-full mat-select-slim">
      <mat-select
        multiple
        [value]="selectionState().uiSelectedValues"
        [hideSingleSelectionIndicator]="true"
        [placeholder]="emptyLabel()"
        (openedChange)="onOpenedChange($event)"
        (closed)="onPanelClosed()"
        (selectionChange)="onSelectionChange($event)"
      >
        <mat-select-trigger>
          <span>{{ triggerLabel() }}</span>
        </mat-select-trigger>

        <div class="flex items-center" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
          <button
            mat-flat-button
            color="secondary-transparent"
            class="mat-slim-button"
            type="button"
            (click)="onSelectAll($event)"
          >
            {{ 'shared.selectAll' | translate }}
          </button>
          <button
            mat-flat-button
            color="secondary-transparent"
            class="mat-slim-button"
            type="button"
            (click)="onUnselectAll($event)"
          >
            {{ 'shared.unselectAll' | translate }}
          </button>
        </div>

        @for (campaign of campaignOptions(); track campaign.id) {
          <mat-option [value]="campaign.id">
            <span class="truncate">{{ campaign.name }}</span>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  } @else {
    <ngx-skeleton-loader class="h-[34px]" [theme]="{ height: '34px', width: '252px', 'border-radius': '100vw' }" />
  }
</div>
